import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authContext } from '../contexts/AuthContext';

interface PublicProps {
  children: React.ReactElement;
}

/** Where Authenticated was sending the visitor before it stopped them, if anywhere. */
export const returnPath = (state: unknown): string | null => {
  const from = (state as { from?: { pathname?: unknown; search?: unknown } } | null)?.from;
  if (!from || typeof from.pathname !== 'string' || !from.pathname.startsWith('/') || from.pathname.startsWith('//')) return null;
  return from.pathname + (typeof from.search === 'string' ? from.search : '');
};

/**
 * Signed-out only. A signed-in visitor is sent to where they were headed before they
 * had to sign in, or to their home screen.
 */
const Public = ({ children }: PublicProps) => {
  const context = useContext(authContext);
  const location = useLocation();
  return context.auth.id ? <Navigate to={returnPath(location.state) || '/home'} replace /> : children;
};

export default Public;
